import React, { startTransition, useEffect, useState,useRef } from 'react';
import ReactDOM from 'react-dom/client';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider,withAuthenticationRequired,useAuth0  } from '@auth0/auth0-react';
import CommonLoader from './components/CommonLoader';
// import { Provider } from 'react-redux';
// import store from './redux/store';
import defaultTheme from './Theme'
import * as Sentry from "@sentry/react";
import Disclaimer from './pages/Disclaimer';
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";


const isProduction = process.env.REACT_APP_DASHBOARD_SENTRY_ENVIRONMENT === 'production';
const queryClient = new QueryClient();

// Sentry.init({
//   // dsn: process.env.REACT_APP_DASHBOARD_SENTRY_DSN,
//   dsn: 'https://9b61eacfd6287915ae5954c24d4ebf10@o4508838813368320.ingest.de.sentry.io/4508843209326672',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     ...(isProduction ? [Sentry.replayIntegration()] : []),
//   ],
//   environment: 'development',
//   release: "javascript-react1@1.0.0",

//   tracePropagationTargets: [ "http://localhost:3000", "https://ttgv1.demopsts.com", /^https:\/\/yourserver\.io\/api/], // Include localhost

//   replaysSessionSampleRate: isProduction ? 1.0 : 0.0,
//   replaysOnErrorSampleRate: isProduction ? 1.0 : 0.0,
// });


// const ProtectedApp = withAuthenticationRequired(App); //If user not authenticated, redirect to auth0 login page

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <ThemeProvider theme={defaultTheme}>
//     {/* <Provider store={store}> */}
//       <Auth0Provider
//         domain= {process.env.REACT_APP_AUTH0_DOMAIN}
//         clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
//         authorizationParams={{
//           redirect_uri: window.location.origin,
//           audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          
//         }}
//         scope="openid profile email"
//       >
//        {!localStorage?.getItem('disclaimer_popup') ? <Disclaimer/> : <ProtectedApp  />}
//       </Auth0Provider>
//     {/* </Provider> */}
//   </ThemeProvider >
// );

// const RootComponent = () => {
//   const isDisclaimerAccepted = localStorage.getItem("disclaimer_popup");
//   const isLogout = localStorage.getItem('logout')
//   const [disclaimerPage, setDisclaimerPage] = React.useState(true);
//   const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  
//   useEffect(() => {
//     if(isLogout == "true") {
//       setTimeout(() => {
//         localStorage.removeItem('logout');
//       },500)
//     }
//   }, [isLogout])

//   if (isLoading) {
//     return <CommonLoader />;
//   }

//   if (!isAuthenticated) {
//     loginWithRedirect();
//     return <CommonLoader />;
//   }
//   console.log("isAuthenticated ",isAuthenticated)

// console.log("isLogout " )
//   return (
//     <ThemeProvider theme={defaultTheme}>
//       <Auth0Provider
//         domain={process.env.REACT_APP_AUTH0_DOMAIN}
//         clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
//         authorizationParams={{
//           redirect_uri: window.location.origin,
//           audience: process.env.REACT_APP_AUTH0_AUDIENCE,
//         }}
//         scope="openid profile email offline_access"
//           cacheLocation="localstorage"  // Needed to persist tokens across refresh
//           useRefreshTokens={true} 
//       >
//         <QueryClientProvider client={queryClient}>
//         {(isDisclaimerAccepted || isLogout == "true") ? <App /> : isLogout == null && <Disclaimer isOpen={disclaimerPage} setDisclaimerPage={setDisclaimerPage} />}
//           <ReactQueryDevtools initialIsOpen={false} />
//         </QueryClientProvider>
//       </Auth0Provider>
//     </ThemeProvider>
//   );
// };

const AuthWrapper = () => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  const [showDisclaimer, setShowDisclaimer] = React.useState(false);
  const [redirecting, setRedirecting] = React.useState(false);
    const isDisclaimerAccepted = localStorage.getItem("disclaimer_popup");
    console.log("isDisclaimerAccepted ",isDisclaimerAccepted)

  // 🔥 Check disclaimer only once on mount
  useEffect(() => {
    const isLogout = localStorage.getItem("logout");

    if(!isDisclaimerAccepted && isLogout !='true') {
      console.log("within")
      setShowDisclaimer(true);
    }
    console.log("out1st")
    setTimeout(() => {
      localStorage.removeItem("logout");
    },500)

  }, []);

  // 🔥 Handle login redirect AFTER disclaimer
  useEffect(() => {
    if (!isLoading && !isAuthenticated && !showDisclaimer && !redirecting) {
      setRedirecting(true);

      startTransition(() => {
        loginWithRedirect();
      });
    }
  }, [isLoading, isAuthenticated, showDisclaimer, loginWithRedirect]);

  // 🔥 Show loader during auth / redirect
  if (isLoading || redirecting) {
    return <CommonLoader />;
  }

  // 🔥 Show Disclaimer BEFORE login
  if (showDisclaimer) {
    return (
      <Disclaimer
        isOpen={showDisclaimer}
        onAccept={() => {
          localStorage.setItem("disclaimer_popup", "true");
          // 🔥 Delay redirect to next tick (prevents suspend error)
          setTimeout(() => {
            startTransition(() => {
              setRedirecting(true);
              loginWithRedirect();
            });
          }, 0);

          setShowDisclaimer(false);
        }}
      />
    );
  }

  // 🔥 Not authenticated yet → waiting for redirect
  if (!isAuthenticated) {
    return <CommonLoader />;
  }

  // 🔥 Authenticated → load app
  return <App />;
};



// const AuthWrapper = () => {
//   const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

//   const isDisclaimerAccepted = localStorage.getItem("disclaimer_popup");
//   const isLogout = localStorage.getItem("logout");

//   const [showDisclaimer, setShowDisclaimer] = React.useState(false);

//   // 🔥 Decide whether to show disclaimer
//   React.useEffect(() => {
//     if (!isDisclaimerAccepted) {
//       setShowDisclaimer(true);
//     }
//   }, [isDisclaimerAccepted, isLogout]);

//   // 🔥 Trigger login ONLY after disclaimer accepted
//   React.useEffect(() => {
//     if (!isLoading && !isAuthenticated && !showDisclaimer) {
//        startTransition(() => {
//       loginWithRedirect();
//     });
//     }
//   }, [isLoading, isAuthenticated, showDisclaimer, loginWithRedirect]);

//   if (isLoading) {
//     return <CommonLoader />;
//   }

//   // 🔥 Show Disclaimer FIRST (before login)
//   if (showDisclaimer && isLogout !='true') {
//     return (
//       <Disclaimer
//        isOpen={showDisclaimer} setShowDisclaimer={setShowDisclaimer}
//       />
//     );
//   }

//   if (!isAuthenticated && isLoading) {
//     return <CommonLoader />;
//   } else if(!isAuthenticated && !isLoading) {
//     loginWithRedirect();
//   }

//   return <App />;
// };

// 🔥 Root App
const RootApp = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
        }}
        scope="openid profile email offline_access"
        cacheLocation="localstorage"
        useRefreshTokens={true}
      >
        <QueryClientProvider client={queryClient}>
          <AuthWrapper />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </Auth0Provider>
    </ThemeProvider>
  );
};


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootApp />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
